// Steamer reveal for the steamed bun. The lid is a second bamboo tier that
// rests beside the steamer in the model. At load it starts closed over the
// bun, pauses, lifts straight up until it clears the bun, moves across while
// raised, then lowers onto the floor. Separate phases keep it from cutting
// through the bun or the steamer wall.
const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
const smooth=t=>{t=clamp(t,0,1);return t*t*(3-2*t);};
export const REVEAL_SECONDS=2.05;
// rise: 0 seated on the steamer, 1 fully raised. travel: 0 over the steamer,
// 1 above its resting place. drop: 0 raised, 1 on the floor. tilt in radians.
export function lidPose(t){
  if(t>=REVEAL_SECONDS)return {rise:1,travel:1,drop:1,tilt:0};
  const rise=smooth((t-.35)/.5),travel=smooth((t-.9)/.7),drop=smooth((t-1.6)/.4);
  return {rise,travel,drop,tilt:.08*Math.sin(Math.PI*travel)};
}
// Soft steam released as the lid lifts. Positions are relative to the steamer
// top, in units of the bun radius.
export function steamPuffs(t,count){
  return Array.from({length:count},(_,i)=>{
    const born=.45+i*.11,age=t-born,life=1.6;
    if(age<0||age>life)return {x:0,y:0,z:0,scale:0,opacity:0};
    const k=age/life,a=i*2.399;
    return {x:.3*Math.cos(a)*(.5+k)+.12*Math.sin(age*3+i),y:.2+1.3*k,z:.3*Math.sin(a)*(.5+k),scale:.5+1.1*k,opacity:.72*Math.sin(Math.PI*k)**1.5};
  });
}
